module.exports = __webpack_public_path__ + "media/images/home/studenti02-9e2a09a20e10bbe2593e7aab0f515665.svg";